import { Link, useLocation, useMatch } from 'react-router-dom'

import { useTranslation } from 'react-i18n-lite'

import { isEmbedded } from 'shared/utils/iframe'

export default function TopAreaNavigation() {
  const { t } = useTranslation()

  const location = useLocation()

  const isHomePage = useMatch('/')
  const isInteractionPage = useMatch(
    'interaction/:workflowUUID/:interactionUUID'
  )
  const isMasterdataPage = useMatch('masterdata/:workflowUUID/:interactionUUID')
  const isWorkflowmodelsListPage = useMatch('workflowmodel/list')

  const shouldDisplayWorkflowLink = isInteractionPage || isMasterdataPage

  const workflowUUID = location.pathname.split('/')[2]

  const containerStyles = {
    display: 'flex',
    gap: '2rem'
  }

  if (isHomePage || isEmbedded()) return null

  return (
    <div style={containerStyles} className='m-4'>
      {!isWorkflowmodelsListPage && (
        <Link to='/workflowmodel/list'>
          {t('navigation.workflowmodel-list')}
        </Link>
      )}

      {shouldDisplayWorkflowLink && (
        <Link to={`/workflow/${workflowUUID}?displayList=true`}>
          {t('navigation.back-to-workflow')}
        </Link>
      )}
    </div>
  )
}
